module.exports = __webpack_public_path__ + "static/media/electric_scooter_white.2d5a9251.svg";